import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

import Pill from '../../../common/Pill';
import Checkbox from '../../../common/Checkbox';

const MembershipShops = props => (
  <div className="u-width-100">
    <div className="c-membership-stats-container u-mt+">
      <div className="c-memberships-container">
        <div className="c-memberships-container__text_small">Created By</div>
        <div className="c-memberships-container__title u-type--capitalize">
          {props.membershipOwnerType}
        </div>
      </div>
      <div className="c-memberships-container">
        <div className="c-memberships-container__text_small">Locations Assigned</div>
        <div className="c-memberships-container__title">
          {props.assignedLocations}/{props.totalLocations}
        </div>
      </div>
      <div className="c-memberships-container">
        <div className="c-memberships-container__text_small">Total Members</div>
        <div className="c-memberships-container__title">{props.totalMembers}</div>
      </div>
      <div className="c-memberships-container">
        <div className="c-memberships-container__text_small">Active Members</div>
        <div className="c-memberships-container__title">{props.activeMembers}</div>
      </div>
    </div>
    <div className="u-text-right u-mt+">
      <button
        disabled={!props.canSaveAssignment || props.busy}
        className="c-btn c-btn--medium"
        onClick={props.saveAssignments}
      >
        Assign Locations
      </button>
    </div>
    <ReactTable
      className="c-table-new c-table-paginated c-no-hover u-mt+ u-mb"
      data={props.items}
      minRows={0}
      defaultPageSize={2000}
      showPagination={false}
      resizable={false}
      columns={[
        {
          Header: 'Assignment',
          accessor: row => props.shopAssignments[row.shopId],
          id: 'assignment',
          maxWidth: 80,
          Cell: row => (
            <div>
              <Checkbox
                checked={row.value}
                disabled={props.busy}
                onChange={() => props.toggleAssignment(row.original)}
              />
            </div>
          ),
        },
        {
          Header: 'Location',
          accessor: 'name',
          id: 'name',
          Cell: row => (
            <div>
              {row.value} <Pill type="primary" className="u-ml-" display-if={row.original.isCreator}>Creator</Pill>
            </div>
          ),
        },
        {
          Header: 'Members',
          accessor: row => (row.counts ? row.counts.total : 'N/A'),
          id: 'total',
        },
        {
          Header: 'Active Members',
          accessor: row => (row.counts ? row.counts.active : 'N/A'),
          id: 'active',
        },
        {
          Header: 'Status',
          accessor: 'status',
          id: 'status',
          Cell: row => (
            <div className={`c-memberships-status c-memberships-status__${row.value}`}>
              {row.value}
            </div>
          ),
        },
      ]}
    />
  </div>
);

MembershipShops.propTypes = {
  membershipOwnerType: PropTypes.string.isRequired,
  assignedLocations: PropTypes.number.isRequired,
  totalLocations: PropTypes.number.isRequired,
  totalMembers: PropTypes.number.isRequired,
  activeMembers: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired,
  canSaveAssignment: PropTypes.bool.isRequired,
  busy: PropTypes.bool.isRequired,
  toggleAssignment: PropTypes.func.isRequired,
  saveAssignments: PropTypes.func.isRequired,
};

export default MembershipShops;
